import { render, staticRenderFns } from "./TableBuyerInProcess.vue?vue&type=template&id=246a47ba&"
import script from "./TableBuyerInProcess.vue?vue&type=script&lang=ts&"
export * from "./TableBuyerInProcess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports